import buttonComponent from './index.vue'

const buttonContent = {
    install : (Vue) => {
        Vue.component('buttonContent', buttonComponent);
    }
}

export default buttonContent



// WEBPACK FOOTER //
// ./src/base/button/index.js